import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { Select } from "@instructure/ui-select";
import FormInputLoader from "../FormInputLoader/FormInputLoader";
import styles from "./FormSelectInput.module.scss";

const IasFormSelectInput = ({
  options,
  placeholder,
  reset,
  label,
  id,
  name,
  onSelected,
  isDisabled,
  selected,
  isLoading,
  messages
}) => {
  const [inputValue, setInputValue] = useState();
  const [isShowingOptions, setIsShowingOptions] = useState(false);
  const [highlightedOptionId, setHighlightedOptionId] = useState(null || selected?.id);
  const [selectedOptionId, setSelectedOptionId] = useState(null || selected?.id);

  useEffect(() => {
    if (!reset) return;

    setInputValue("");
    setSelectedOptionId(null);
  }, [reset]);

  const getOptionById = queryId => {
    return options.find(({ id }) => id === queryId);
  };

  const handleShowOptions = event => {
    setIsShowingOptions(true);
  };

  const handleHideOptions = event => {
    if (!selectedOptionId) return;
    const option = getOptionById(selectedOptionId).title;
    setIsShowingOptions(false);
    setHighlightedOptionId(null);
    setInputValue(selectedOptionId ? option : "");
  };

  const handleBlur = event => {
    if (selectedOptionId === null) {
      setInputValue("");
    }
    setIsShowingOptions(false);
    setHighlightedOptionId(null);
  };

  const handleHighlightOption = (event, { id }) => {
    event.persist();
    const option = getOptionById(id).title;

    setHighlightedOptionId(id);
    setInputValue(event.type === "keydown" ? option : inputValue);
  };

  const handleSelectOption = (event, { id }) => {
    const option = getOptionById(id).title;

    setSelectedOptionId(id);
    setInputValue(option);
    setIsShowingOptions(false);
    onSelected(name, option);
  };

  return (
    <div className={classnames(styles.FormSelectInput)}>
      <FormInputLoader hide={!isLoading} />

      <Select
        color={"#FFFFFF"}
        fontSize="4rem"
        placeholder={placeholder}
        renderLabel={label}
        size={'medium'}
        messages={messages}
        interaction={
          options.length === 0 || isDisabled ? "disabled" : "enabled"
        }
        assistiveText="Use arrow keys to navigate options."
        inputValue={selected ? selected.title : inputValue}
        isShowingOptions={isShowingOptions}
        onBlur={handleBlur}
        onRequestShowOptions={handleShowOptions}
        onRequestHideOptions={handleHideOptions}
        onRequestHighlightOption={handleHighlightOption}
        onRequestSelectOption={handleSelectOption}
        id={id}
        name={name}
      >
        {options.map(option => {
          return (
            <Select.Option
              id={option.id}
              key={option.id + option.title}
              isHighlighted={option.id === highlightedOptionId}
              isSelected={option.id === selectedOptionId}
            >
              {option.title}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export default IasFormSelectInput;
